// const tableModelHeight = document.querySelector('.table-model-header').getBoundingClientRect().height || document.querySelector('.table-model-header').clientHeight;
// document.documentElement.style.setProperty('--table-model-header', `${tableModelHeight}px`);
// window.addEventListener('resize', function() {
//   document.documentElement.style.setProperty('--table-model-header', `${tableModelHeight}px`);
// });
let productsScript = document.getElementById('comparison-product'); // 获取所有瞄具
let products = JSON.parse(productsScript.textContent).product; // 转json格式
let selectedProducts = []; // 当前选中对比产品(不能大于4)
// 选对比产品
$('.table-th .table-th-empty').click(function() {
  $('.product-floating-window').addClass('active');
});
// 关闭产品弹窗
$('.product-window-hd .close').click(function() {
  $('.product-floating-window').removeClass('active');
});
// 删除对比产品
$('.table-th-close').click(function() {
  const index = parseInt($(this).parent().data('index'));
  const length = selectedProducts.length;
  $(`.table-th[data-index="${length - 1}"]`).children('.table-th-close').hide().siblings('.table-th-empty').show();
  $(`div[data-product-id="${selectedProducts[index].id}"]`).removeClass('no-click');
  selectedProducts.splice(index, 1);
  $('.table-td, .product-info, .product-title').remove();
  if (selectedProducts.length <= 1 && $('#highlight').is(':checked')) {
    $('.table-tr').removeClass('td-diff');
  }
  handleHtml();
});
// 删除所有对比产品
$('.remove-all').click(function() {
  selectedProducts = [];
  $('.table-td, .product-info, .product-title').remove();
  $('.product-window-bd .item').removeClass('no-click');
  $('.table-th-close').hide();
  $('.table-th-empty').show();
  if ($('#highlight').is(':checked')) {
    $('#highlight').prop('checked', false);
    $('.table-tr').removeClass('td-diff');
  }
  handleHtml();
  window.localStorage.removeItem('shareId');
});
// 添加对比产品
$('.product-window-bd .item').click(function() {
  let id = $(this).data('product-id');
  if (selectedProducts.length > 0 && selectedProducts.findIndex(item => item.id === id) > -1) return;
  const index = products.findIndex(item => item.id === id);
  const product = products[index];
  const specifications = getProductMetafields(product.id)?.Specifications?.value || {};
  $('.product-floating-window').removeClass('active');
  selectedProducts.push({
    id: product.id,
    title: product.title,
    handle:  product.handle,
    featured_image: $(`div[data-product-id='${product.id}']`).data('featured-image') || product.featured_image,
    price: $(`div[data-product-id='${product.id}']`).data('price'),
    specifications: specifications
  });
  $('.table-td, .product-info, .product-title').remove();
  handleHtml();
  if ($('#highlight').is(':checked')) {
    compareRowCells();
  }
});
var $div = $('.table-container');
var $data = $('div[data-zero-stop]');
$(window).scroll(function () {
  var scrollTop = $(window).scrollTop();
  if (scrollTop > 0 && scrollTop >= ($div[0].offsetTop - $(".section-header").outerHeight() - $(".announcement-bar-section").outerHeight())) {
    $('.mobile-arrow').addClass('active');
  } else {
    $('.mobile-arrow').removeClass('active');
  }
  if (scrollTop > $data[0].offsetTop ) {
    $('.mobile-arrow').removeClass('active');
  }
});
$(function() {
  // 动态获取表单Header高度
  var target = document.querySelector('.table-model-header');
  var observer = new ResizeObserver(function(entries) {
      for (var entry of entries) {
        let tableModelHeight = entry.contentRect.height.toFixed(2);
        document.documentElement.style.setProperty('--table-model-header', `${tableModelHeight}px`);
      }
  });
  observer.observe(target);

  var isSyncing = false; // 同步锁，防止循环触发
  function syncScroll($source, $target) {
    if (isSyncing) return;
    isSyncing = true;
    // 同步水平滚动位置
    $target.scrollLeft($source.scrollLeft());
    // 用 requestAnimationFrame 或 setTimeout 解锁，确保不会在同一帧内循环
    requestAnimationFrame(function() {
      isSyncing = false;
    });
  }
  $('.table-header').on('scroll', function() {
    syncScroll($(this), $('.table-body, .table-model-header'));
  });
  $('.table-body').on('scroll', function() {
    syncScroll($(this), $('.table-header, .table-model-header'));
  });
  $('.table-model-header').on('scroll', function() {
    syncScroll($(this), $('.table-header, .table-body'));
  });

  // 获取导航类型
  var navEntries = performance.getEntriesByType("navigation");
  var navType = navEntries.length > 0 ? navEntries[0].type : null;
  let shareIds = window.localStorage.getItem('shareId');
  if (!shareIds) return;
  let pids = shareIds.split(',');
  // 兼容旧浏览器（Chrome < 76, Safari 等）
  if (!navType && performance.navigation) {
    var typeMap = { 0: "navigate", 1: "reload", 2: "back_forward", 255: "reserved" };
    navType = typeMap[performance.navigation.type];
  }
  if (navType === "back_forward") {
    selectedProducts = [];
    $('.table-td, .product-info, .product-title').remove();
    $('.table-th-close').hide();
    $('.table-th-empty').show();
    handleHtml();

    pids.forEach(pid => {
      const index = products.findIndex(item => item.id === parseInt(pid));
      const p_index = selectedProducts.findIndex(item => item.id === parseInt(pid));
      if (p_index >= 0) return;
      const product = products[index];
      const specifications = getProductMetafields(product.id)?.Specifications?.value || {};
      selectedProducts.push({
        id: product.id,
        title: product.title,
        handle: product.handle,
        featured_image: $(`div[data-product-id='${product.id}']`).data('featured-image') || product.featured_image,
        price: $(`div[data-product-id='${product.id}']`).data('price'),
        specifications: specifications
      });
    });
    handleHtml();
  } else {
    window.localStorage.removeItem('shareId');
  }
});
$(document).on('click', '.table-td .reticle', function() {
  openModal($(this).data('image-pc'), $(this).data('image-mobile'), $(this).data('image-alt'));
});
$(document).ready(function() {
  let $header = $('.table-header');
  let $body = $('.table-body');
  let maxScrollLeft = $header[0].scrollWidth - $header[0].clientWidth;
  $('.mobile-arrow .left').click(function () {
    $header.animate({ scrollLeft: 0 }, 300);
    $body.animate({ scrollLeft: 0 }, 300);
  });
  $('.mobile-arrow .right').click(function () {
    $header.animate({ scrollLeft: maxScrollLeft }, 300);
    $body.animate({ scrollLeft: maxScrollLeft }, 300);
  });
  document.querySelector('#highlight').addEventListener('click', function() {
    this.classList.toggle('checked');
  });
  $('#highlight').change(function() {
    if ($(this).is(':checked')) {
      compareRowCells();
    } else {
      $('.table-tr').removeClass('td-diff');
    }
  });
  $(".competition-mobile-banner .image-with-text-overlay__buttons .btn").prepend('<svg t="1787723623740" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4369" width="50" height="50"><path d="M229.47294922 935.31728516c-84.84521484 0-153.56865234-70.88203125-153.56865235-158.41582032V241.37949219c0-87.44414063 68.72607422-158.41933594 153.56865235-158.41933594h120.68789062c23.99150391 0.00351562 45.92988281 8.74775391 45.92988282 36.08701172s-20.38974609 33.72099609-45.97119141 33.72099609h-138.25195313c-35.92529297 10.54335937-58.85947266 34.16044922-69.08378906 71.25292969v570.24492188c10.22431641 37.08544922 33.15849609 60.69902343 69.08378907 71.28720703h552.80478516c35.96660156-10.58818359 58.85947266-34.20175781 69.08378905-71.28720703V627.86445313c0-26.18173828 8.41816406-47.27548828 35.24589844-47.27548829 26.82070313 0 31.640625 21.09375001 31.640625 47.39941407v157.33125c0 87.53378906-68.72607422 149.99765625-153.57480469 149.99765625H229.47294922z m487.70332031-439.00400391c-8.92617187 0-16.33535156-1.78857422-21.80126953 0-17.72929687-13.93505859-28.05644531-31.44111328-21.83554688-44.99912109v-44.99208985c-159.35625001-11.23330078-336.77226562 146.14189453-378.38935546 292.47363282-9.14589844-32.12138672-14.19609375-66.02080078-14.19609375-101.21835938 0-195.72802734 199.63916016-405.01054688 392.58632812-416.25175781V136.33613281c-6.22089844-13.56152345 4.10625001-31.06054688 21.83554688-44.99208984 5.45888672 1.78505859 12.87421875 0 21.79423828 0 8.69941406 0 18.91054688 3.45410156 21.82851562 0L937.76855469 253.35458985c12.14648438 9.53085938 19.31572266 24.56455078 19.31572265 40.47099609 0 15.90996094-7.16835938 30.94365234-19.31572265 40.47451172L738.99775391 496.31328125c-2.91796875-3.46025391-13.12822266 0-21.82148438 0z" p-id="4370" fill="#000000"></path></svg>');
  $('.competition-mobile-banner .image-with-text-overlay__buttons .btn').click(function () {
    shareToFacebook();
  });
});
// 初始化对比产品列表
function initCompetition() {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  let queryParams = {};
  let i = 0;
  selectedProducts = [];
  params.forEach((value, key) => {
    queryParams[key] = value;
    if (queryParams.shareId) {
      if (i > 3) return;
      i++;
      let pids = queryParams.shareId ? queryParams.shareId.split(',') : [];
      pids.forEach(pid => {
        const index = products.findIndex(item => item.id === parseInt(pid));
        const p_index = selectedProducts.findIndex(item => item.id === parseInt(pid));
        if (p_index >= 0) return;
        const product = products[index];
        const specifications = getProductMetafields(product.id)?.Specifications?.value || {};
        selectedProducts.push({
          id: product.id,
          title: product.title,
          handle: product.handle,
          featured_image: $(`div[data-product-id='${product.id}']`).data('featured-image') || product.featured_image,
          price: $(`div[data-product-id='${product.id}']`).data('price'),
          specifications: specifications
        });
      });
    }
  });
  handleHtml();
}
// 生成dom
function handleHtml() {
  if (selectedProducts.length === 0) {
    window.localStorage.removeItem('shareId');
    return;
  }
  let pids = '';
  selectedProducts.forEach((item, index) => {
    $(`div[data-product-id="${item.id}"]`).addClass('no-click');
    pids += index === 0 ? item.id : "," + item.id;
    window.localStorage.setItem('shareId', pids);
    $(`.table-th[data-index="${index}"]`).children('.table-th-close').show().siblings('.table-th-empty').hide();
    // 标题
    let titleElement = null;
    titleElement = $(`.table-model-th[data-index="${index}"]`);
    titleElement.append(`<div class="product-title"><a href="https://www.arkenopticsusa.com/products/${item.handle}">${truncateString(item.title)}</a></div>`);
    // 头部
    let element = null;
    element = $(`.table-th[data-index="${index}"]`);
    element.children('.table-th-empty').hide();
    element.append('<div class="product-info">' +
      `<a href="https://www.arkenopticsusa.com/products/${item.handle}"><img src="${item.featured_image}" alt="${item.title}"></a>` +
      `<div class="product-price">${item.price}</div>` +
      `<div class="quick-add no-js-hidden custom-quik-view">
              <quick-view class="btn btn-primary" tabindex="0" data-product-handle="${item.handle}" role="button" aria-label="Quick view">
                <span class="custom-add-cart-txtx">Add to Cart</span>
                <div class="loading__spinner">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </quick-view>
            </div>` +
      '</div>');
    item.specifications.forEach(item => {
      if (item.label === 'data-reticle') {
        let images = '';
        if (typeof item.value === 'object') {
          item.value.forEach(val => {
            images += `<span class="reticle" data-reticle-detail data-image-pc="${val.previewP}" data-image-mobile="${val.previewM}" data-image-alt="${item.title}">${val.label}</span>`
          })
        } else {
          images = item.value || '/'
        }
        $(`div[${item.label}]`).append(`<div class="table-td">${images}<svg width="29" height="27" viewBox="0 0 29 27"><image width="29" height="27" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAYAAACAyoQSAAADL0lEQVRIib2Wy0tbQRjFTx6a+IiEqBitIkTsQnSjiKGggg+yCIKIiFs3Qlftn1BakO4L3ei6dSNCEUWSIEEJoqALRQTFKj4bFQUVURNTztfcoObeeE3VA8lNZob5zfecaxgYGAAAJ4AvAN4BsOL5FQbwE8A3ADEzAAuAIIC3LwBT5ALgBuAA8MkIwPPCwLv6wN+EvnklIGUHYDPrWVlaWoqGhgZUVFTAZDLJ2PHxMRYWFrC0tISrq6ungI0poUajEV1dXaisrEQsFkM4HMbR0RGsVivKysrQ3t6OpqYmjIyMYGtrSzdVE2qxWNDb24uSkhLMzc1henoa19fX99a4XC54PB5ZR/D6+ro+U7UmmpubBTg6OopAIJAEpDY2NjA4OIiTkxN0dHQgOzs7fWhubi7q6uowOzuL1dXVxLjD4UBfXx/sdntiLBKJYHh4WFze2NiYPrS+vl6e8/Pz98ZpidPpTLLo7OxMEqq2tjZ9KBNnb28vkZX5+fkoLi6WJ1VQUCBwPikm2fb2dmLtY1JNpJycHJyeniIajSIjI0PiRagir9crv7hmaGgINzc3iQNmZWWlB724uJAYsSa54eTkpPynZW1tbfD5fFI6jCfnEc926vLyMj3o2toa3G63bMRN9/f3ZVwB0PX8KDIYDFK3iDeNx6QaUyWBlIRSRCsODw+TrLHZbKipqZEOpUeq0PPzcywuLoq1TCpFtIIxZF0qYgh6enokg4PBYPpQampqCgcHB+ju7kZLSwvM5uRIlJeXo7+/H4WFhZJ0t7e3uqC8xN8D+K42SVBnZ2ei9zKOtJKx5iXATKWFHCOQh2QPZqdKIbuptbWVgfOqzXKjlZUVbG5uIi8vT0BFRUVSi4xrKBTC2NiYNIbMzEzpSFVVVZLVu7u7WtCvuq62nZ0daXWIx5CHoeV3RQj7M0uL4WDf9vv94omH0oyplhi7h0CKZaUcDPEbqLq6WnWXJ0NTieDx8XFx78zMjFz6atLl3qdoeXlZXM0aZwVoQZN99R+i+9kiJyYmtDaJ0L2/n9vaFPrD1k6oH0DolaCf+UX3RuPvvh/jL8T/rovnFW+BHwB+AcBfbKpZSXBTCIQAAAAASUVORK5CYII="/></svg></div>`);
      } else {
        $(`div[${item.label}]`).append(`<div class="table-td">${item.value || '/'}</div>`);
      }
    });
  });
}
// 截取标题
function truncateString(str) {
  // 定义要查找的字符串数组
  const keywords = ['FFP LPVO Bundle', 'SFP LPVO Bundle', 'FFP', 'SFP'];
  // 遍历每个关键词
  for (let keyword of keywords) {
    // 查找关键词的索引
    let index = str.indexOf(keyword);
    // 如果找到了关键词
    if (index !== -1) {
      // 截取到关键词的位置，并返回结果
      return str.substring(0, index + keyword.length);
    }
  };
  // 如果没有找到任何关键词，返回原始字符串
  return str;
}
// 不同高亮
function compareRowCells() {
  // 遍历表格中的每一行
  $('.table-tr').each(function () {
    const $tr = $(this);
    const $tds = $tr.find('.table-td').not('.table-td-fixed');
    let tdArr = [];
    if ($tds.length < 2) {
      $tr.removeClass('td-diff');
      return;
    }
    function getCleanText($element) {
      return $.trim($element.text()).replace(/\s+/g, ' ');
    }
    // var baseText = getCleanText($tds.eq(0));
    $tds.each(function () {
      const $currentTd = $(this);
      const currentText = getCleanText($currentTd);
      tdArr.push(currentText);
    });
    const uniqueArr = Array.from(new Set(tdArr));
    if (uniqueArr.length <= 1) {
      $tr.removeClass('td-diff');
    } else {
      $tr.addClass('td-diff');
    }
  });
}
// 读取某个产品的 metafields
function getProductMetafields(productId) {
  const script = document.getElementById('product-metafields-' + productId);
  return script ? JSON.parse(script.textContent) : {};
}
// 初始化：判断URL是否含有已选中对比产品ID
function hasParameter(param) {
  return new URLSearchParams(window.location.search).has(param);
}
if (hasParameter('shareId')) {
  initCompetition();
}
function openModal(imagePcSrc, imageMobileSrc, imageAlt) {
  if (!imagePcSrc && !imageMobileSrc) {
    console.warn('No image source provided');
    return;
  }
  // 查找所有模态框（可能有多个 section）
  const modals = document.querySelectorAll('.reticles-modal');

  modals.forEach(modal => {
    const modalImagePc = modal.querySelector('[data-modal-image-pc]');
    const modalImageMobile = modal.querySelector('[data-modal-image-mobile]');
    const modalContent = modal.querySelector('.reticles-modal__content');

    if (modalImagePc && modalImageMobile && modalContent) {
      // 显示 loading 状态
      modalContent.classList.add('is-loading');

      // 显示模态框
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // 预加载图片
      let loadedCount = 0;
      const totalImages = 2;
      const startTime = Date.now();
      const minLoadingTime = 300; // 最小加载时间300ms，避免闪烁

      const checkAllLoaded = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          // 计算已经过去的时间
          const elapsedTime = Date.now() - startTime;
          const remainingTime = Math.max(0, minLoadingTime - elapsedTime);

          // 确保至少显示最小加载时间，避免闪烁
          setTimeout(() => {
            modalContent.classList.remove('is-loading');
          }, remainingTime);
        }
      };

      // 加载 PC 端图片
      if (imagePcSrc) {
        const imgPc = new Image();
        imgPc.onload = () => {
          modalImagePc.src = imagePcSrc;
          modalImagePc.alt = imageAlt;
          checkAllLoaded();
        };
        imgPc.onerror = () => {
          console.error('Failed to load PC image');
          checkAllLoaded();
        };
        imgPc.src = imagePcSrc;
      } else {
        checkAllLoaded();
      }

      // 加载移动端图片
      if (imageMobileSrc) {
        const imgMobile = new Image();
        imgMobile.onload = () => {
          modalImageMobile.src = imageMobileSrc;
          modalImageMobile.alt = imageAlt;
          checkAllLoaded();
        };
        imgMobile.onerror = () => {
          console.error('Failed to load mobile image');
          checkAllLoaded();
        };
        imgMobile.src = imageMobileSrc;
      } else {
        checkAllLoaded();
      }

      // 聚焦到关闭按钮
      const closeButton = modal.querySelector('.reticles-modal__close');
      if (closeButton) {
        setTimeout(() => closeButton.focus(), 100);
      }
    }
  });
}
function shareToFacebook() {
  let parameters = '';
  selectedProducts.forEach((item, index) => {
    parameters += index === 0 ? '?shareId=' + item.id : "," + item.id
  });
  let url = "https://www.arkenopticsusa.com/pages/optic-comparison" + parameters;
  let title = "Arken Optics USA";
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,
    'sharer',
    'width=600,height=300'
  );
}